import styled from 'styled-components';
import { variant } from 'styled-system';
import { Avatar as BaseAvatar } from '../../../../../../../../../../CommonComponents/OPL/Avatar/Avatar';
import { ColorProps } from '../../../../../../../../../../theme/styledProps';
import { VariantProps } from '../../FlowChart.meta';

export const Avatar = styled(BaseAvatar)(
  ({ theme }) => ({
    border: `2px solid ${theme.colors.white}`,
    boxShadow: theme.shadows[300],
    background: 'unset',

    '@media print': {
      boxShadow: 'none',
      border: `1px solid ${theme.colors.neutral['200']}`,
    },
  }),

  variant<ColorProps, VariantProps>({
    prop: 'color',
    variants: {
      neutral: {
        bg: 'neutral.100',
      },

      principal: {
        bg: 'blue.100',
        color: 'blue.700',
      },

      spouse: {
        bg: 'green.100',
        color: 'green.700',
      },

      beneficiaries: {
        bg: 'indigo.100',
        color: 'indigo.700',
      },

      taxesAndFees: {
        bg: 'neutral.100',
      },

      charityBeneficiaries: {
        bg: 'yellow.100',
      },
    },
  }),
);
